import { lazy } from 'react';

const LazySearchPage = lazy(() => import(/* webpackChunkName: "async-ptc_search-page" */ './'));

export default LazySearchPage;
